export default __webpack_public_path__ + "static/media/Logo_white.d918a13b.png";